import { ButtonThird } from '@components/shared/buttons/button-third';
import style from './index.module.scss';
import { ButtonHandshkaeGreen } from '@components/shared/buttons/button-handshake-green';

interface IStartProjectBlockProps {
  title: string;
  buttonText: string;
  link?: string;
  showIntoView?: () => void;
}

export const StartProjectBlock = ({ title, buttonText, showIntoView }: IStartProjectBlockProps) => {
  return (
    <section className={`${style.section}`}>
      <div className={`${style.block}`}>
        <h2 className={`${style.title}`}>{title}</h2>
        <div className={`${style.button}`}>
          <ButtonHandshkaeGreen className={'white'} text={buttonText} action={showIntoView} />
        </div>
      </div>
    </section>
  );
};
